import { useOnboardingStatus } from "../../../onboarding/useOnboardingStatus";

import { JSX } from "react";

import { Chip, ChipProps } from "@mui/material";

const STATUS_COLOR: Record<
  ReturnType<typeof useOnboardingStatus>,
  ChipProps["color"]
> = {
  checking: "default",
  ready: "success",
  "needs-administration-area": "warning",
  "fetch-error": "error",
};

export default function DevOnboardingStatusIndicator(): JSX.Element | null {
  const status = useOnboardingStatus();

  return (
    <Chip
      size="small"
      variant="outlined"
      color={STATUS_COLOR[status]}
      label={`onboarding: ${status}`}
    />
  );
}
